export const focusPuzzles = [
  {
    type: "puzzle",
    question: "What comes next? 2, 4, 8, ?",
    correct: "16",
    options: ["10", "12", "16", "18"]
  },
  {
    type: "puzzle",
    question: "Find the odd one out: 🟥 🟥 🟥 🟦 🟥",
    correct: "🟦",
    options: ["🟥", "🟦"]
  },
  {
    type: "puzzle",
    question: "If ALL = 30 and BALL = 40, what is CALL?",
    correct: "40",
    options: ["30", "40", "50", "60"]
  }
];
